import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";

import { GET_API_KEY_GROUPS } from "./gql";
import { SettingsContext } from "../../Context";
import { UserManagementActivationStatus } from "../../types";
import { ApiKeyGroupMappingEntity, ApiKeyGroupMappingStatus } from "./types";

type UseGetApiKeyGroupsProps = {
  apiKeyTeams: string[];
};

const useGetApiKeyGroups = ({ apiKeyTeams }: UseGetApiKeyGroupsProps) => {
  const { onError } = useTypedContext(FlashContext);
  const { activationStatus } = useTypedContext(SettingsContext);

  const { data, loading, error } = useQuery(GET_API_KEY_GROUPS, {
    onError,
    skip: !apiKeyTeams.length || activationStatus !== UserManagementActivationStatus.ACTIVE,
  });

  const groups: ApiKeyGroupMappingEntity[] = useMemo(() => {
    return apiKeyTeams.map((team) => {
      const group = data?.managedUserGroups.find((group) => group.groupName === team);

      return {
        id: group?.id || `unmapped-${team}`,
        description: group?.description || "",
        groupName: team,
        status:
          team === group?.groupName
            ? ApiKeyGroupMappingStatus.MAPPED
            : ApiKeyGroupMappingStatus.UNMAPPED,
      };
    });
  }, [data?.managedUserGroups, apiKeyTeams]);

  return { groups, loading, error };
};

export default useGetApiKeyGroups;
